import { returnCreation } from './return-creation-en.i18n';

export const en = {
  returnCreation,
};
